import * as React from "react";
import type { SVGProps } from "react";
const SvgInfocenter = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M11.989 3.343c-.539-.542-1.126-.904-1.866-1.107-.885-.243-1.964-.24-3.276-.237L6.35 2H3a1 1 0 0 0-1 1v9a1 1 0 1 0 2 0V4h2.763c1.443-.001 2.224-.002 2.83.164.522.144.95.428 1.588 1.34a1 1 0 0 0 1.663-.038c.528-.83 1.006-1.134 1.61-1.289.663-.17 1.487-.169 2.796-.167h.393L20 4.003v14.09l-2.36.007h-.471c-1.202-.005-2.292-.008-3.21.224a4.2 4.2 0 0 0-1.972 1.101c-.54-.54-1.129-.899-1.87-1.1-.885-.242-1.962-.24-3.27-.236l-.497.001H4v-2.02a1 1 0 1 0-2 0v3.02a1 1 0 0 0 1 1h3.766c1.436-.002 2.217-.002 2.824.163.526.144.955.428 1.592 1.333a1 1 0 0 0 1.662-.04c.527-.83 1.004-1.13 1.607-1.283.656-.166 1.468-.165 2.752-.163h.44l3.36-.01a1 1 0 0 0 .997-1V3a1 1 0 0 0-1.003-1l-3.357.01h-.445c-1.213-.004-2.312-.007-3.238.23a4.2 4.2 0 0 0-1.968 1.103M13 7v2h-2V7zm0 4v6h-2v-6z"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgInfocenter;
